<template>
    <div>
        <v-container>
            <v-toolbar dense flat color="transparent">
                <v-toolbar-title class="font-weight-bold"
                    >Category Details</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn @click="onDelete()" color="error" text class="ml-2"
                    >Delete</v-btn
                >
                <v-btn @click="onSave()" color="primary" class="ml-2"
                    >Save</v-btn
                >
            </v-toolbar>
            <v-row>
                <v-col cols="4">
                    <v-form ref="editForm">
                        <v-card flat>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Name</div>
                                <v-text-field
                                    v-model="item.name"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Device Code</div>
                                <v-text-field
                                    v-model="item.token"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Location</div>
                                <v-select
                                    v-model="item.location_id"
                                    :items="locations"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    item-text="name"
                                    item-value="id"
                                ></v-select>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-col>
                <v-col cols="4">
                    <v-card flat>
                        <v-card-text class="pb-0">
                            <div class="subtitle-2">Created At</div>
                            <div class="body-1 my-2">
                                {{
                                    $moment(item.created_at).format(
                                        "DD-MM-YYYY HH:mm:ss"
                                    )
                                }}
                            </div>
                        </v-card-text>
                        <v-card-text class="pb-0">
                            <div class="subtitle-2">Updated At</div>
                            <div class="body-1 my-2">
                                {{
                                    $moment(item.updated_at).format(
                                        "DD-MM-YYYY HH:mm:ss"
                                    )
                                }}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modelPath: "smiley-tools/devices",
            locations: [],
            item: {
                name: "",
                location_id: null,
                token: "",
                created_at: "",
                updated_at: "",
            },
        };
    },
    created() {
        this.getItemDetails().then((data) => {
            this.item = data.item;
        });
        this.getListOfDepartments().then((data) => {
            this.locations = data.items;
        });
    },
    methods: {
        onSave: function () {
            if (this.$refs.editForm.validate()) {
                //TODO :- Perform action if the form is validated

                this.updateItem().then((res) => {
                    if ((res.status = 200)) {
                        this.item = res.item;
                    }
                });
            }
        },
        onDelete: function () {
            this.deleteItem().then((res) => {
                if ((res.status = 204)) {
                    this.$router.push("/settings/device");
                }
            });
        },
        getItemDetails: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/${this.modelPath}/${this.$route.params.id}`,
                }).then(function (response) {
                    console.log(response.data);
                    let item = response.data;
                    resolve({
                        item,
                    });
                });
            });
        },
        getListOfDepartments: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/locations`,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        resolve({
                            items,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        updateItem: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "put",
                    url: `/${this.modelPath}/${this.$route.params.id}/`,
                    data: this.item,
                }).then(function (response) {
                    console.log(response.data);
                    let status = response.status;
                    let item = response.data;
                    resolve({
                        status,
                        item,
                    });
                })
                .catch(err => {
                    console.log(err.response);
                    if (err.response.data && err.response.data.token) {
                        alert('Device Code already exist! Use a different Device Code.')
                    }
                });
            });
        },
        deleteItem: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "delete",
                    url: `/${this.modelPath}/${this.$route.params.id}`,
                }).then(function (response) {
                    console.log(response.data);
                    let status = response.status;
                    let item = response.data;
                    resolve({
                        status,
                        item,
                    });
                });
            });
        },
    },
};
</script>
